<template>
    <div>
        <!-- Top-right toasts -->
        <div class="notification-container">
            <div
                v-for="notification in topRightNotifications"
                :key="notification.id"
                :class="['notification', 'notification-' + notification.type]"
            >
                {{ notification.text }}
            </div>
        </div>

        <!-- Centred overlay notices -->
        <transition name="notification-center-fade">
            <div
                v-if="centerNotifications.length"
                class="notification-center-overlay"
                @click.self="dismiss(centerNotifications[0].id)"
            >
                <div
                    v-for="notification in centerNotifications"
                    :key="notification.id"
                    :class="['notification-center-card', 'notification-center-card--' + notification.type]"
                >
                    <button class="notification-center-close" @click="dismiss(notification.id)" aria-label="Dismiss">&times;</button>
                    <div class="notification-center-icon">
                        <i :class="centerIcon(notification.type)"></i>
                    </div>
                    <p class="notification-center-text">{{ notification.text }}</p>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'NotificationContainer',

    props: {
        notifications: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        topRightNotifications() {
            return this.notifications.filter(n => n.position !== 'center');
        },
        centerNotifications() {
            return this.notifications.filter(n => n.position === 'center');
        },
    },

    methods: {
        dismiss(id) {
            this.$emit('dismiss', id);
        },
        centerIcon(type) {
            const icons = {
                success: 'fas fa-check-circle',
                error:   'fas fa-times-circle',
                warning: 'fas fa-exclamation-triangle',
                info:    'fas fa-info-circle',
            };
            return icons[type] || icons.info;
        },
    },
}
</script>

<style scoped>
/* ── Top-right toasts (unchanged) ─────────────────────────────────── */
.notification-container {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 999999;
    pointer-events: none;
}

.notification {
    background: #28a745;
    color: white;
    padding: 12px 16px;
    border-radius: 4px;
    margin-bottom: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    animation: slideIn 0.3s ease-out;
    pointer-events: auto;
    min-width: 200px;
    font-size: 14px;
}

.notification-success { background: #28a745; }
.notification-error   { background: #dc3545; }
.notification-warning { background: #ffc107; color: #212529; }
.notification-info    { background: #17a2b8; }

@keyframes slideIn {
    from { transform: translateX(100%); opacity: 0; }
    to   { transform: translateX(0);    opacity: 1; }
}

/* ── Centred overlay ──────────────────────────────────────────────── */
.notification-center-overlay {
    position: fixed;
    inset: 0;
    z-index: 999999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.45);
}

.notification-center-card {
    position: relative;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
    padding: 36px 40px 32px;
    max-width: 460px;
    width: 90%;
    text-align: center;
    border-top: 4px solid #17a2b8;
}

.notification-center-card + .notification-center-card {
    margin-top: 16px;
}

.notification-center-card--success { border-top-color: #28a745; }
.notification-center-card--error   { border-top-color: #dc3545; }
.notification-center-card--warning { border-top-color: #ffc107; }
.notification-center-card--info    { border-top-color: #17a2b8; }

.notification-center-close {
    position: absolute;
    top: 10px;
    right: 14px;
    background: none;
    border: none;
    font-size: 22px;
    line-height: 1;
    color: #aaa;
    cursor: pointer;
    padding: 0;
}

.notification-center-close:hover {
    color: #555;
}

.notification-center-icon {
    font-size: 36px;
    margin-bottom: 14px;
}

.notification-center-card--success .notification-center-icon { color: #28a745; }
.notification-center-card--error   .notification-center-icon { color: #dc3545; }
.notification-center-card--warning .notification-center-icon { color: #f0ad4e; }
.notification-center-card--info    .notification-center-icon { color: #17a2b8; }

.notification-center-text {
    font-size: 15px;
    color: #333;
    margin: 0;
    line-height: 1.5;
}

/* ── Transition ───────────────────────────────────────────────────── */
.notification-center-fade-enter-active,
.notification-center-fade-leave-active {
    transition: opacity 0.2s ease;
}

.notification-center-fade-enter,
.notification-center-fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/Common/NotificationContainer.vue